"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchField = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchField = (0, _styledComponents["default"])(_.Input).withConfig({
  displayName: "SearchFieldstyle__SearchField",
  componentId: "sc-14ed86m-0"
})(_defineProperty({}, ['::-webkit-search-decoration', '::-webkit-search-cancel-button', '::-webkit-search-results-button', '::-webkit-search-results-decoration'].join(), {
  '-webkit-appearance': 'none'
}));
exports.SearchField = SearchField;